import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH EVENT_LIVE GALLERY FILES TO EDIT ********************
export const fetchEventLiveGallery = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_EVENT_LIVE_GALLERY_FILES_LOADING,
			payload: true
		});

		const response = await services.get(
			`/assets/${id}/list?model_type=live_event&collection=gallery`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_EVENT_LIVE_GALLERY_FILES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_EVENT_LIVE_GALLERY_FILES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** FETCH EVENT_LIVE ASSET GROUP ********************
export const fetchEventLiveAssetGroups = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_EVENT_LIVE_ASSET_GROUP_LOADING,
			payload: true
		});

		const url = `/asset_groups/list?model_id=${id}&with_assets=1`;

		const {
			data: { data }
		} = await services.get(url);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_EVENT_LIVE_ASSET_GROUP_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_EVENT_LIVE_ASSET_GROUP_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
